import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NamedItemInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const LcNamedItem = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.lcdetail"));
  const emptyRecord = {
    tenantCapitalNamedItemId: null
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'namedItem') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)

    _.set(nextData, field, val)

    delete nextData.amt
    delete nextData.amtType
    delete nextData.payout

    setData(nextData);
    props.persist({...nextData, state: 'namedItem'}, 'lcdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)
 
  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>L.C.</label>
          <NamedItemInput 
            className="automated named-item-state-input" 
            data={data} 
            attrs={attrs} 
            field="tenantCapitalNamedItemId" 
            filter={true}
            options={props.namedItems['tenantCapital'].filter(each => each.type === 'lc')} 
            persist={updateData} 
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default LcNamedItem